var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 18,
    fill: "none",
    viewBox: "0 0 13 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#628BF5",
    d: "M0 0h2.091v15.349H0V0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#628BF5",
    d: "M9.921 0H2.09v15.349H9.92c1.403 0 2.59-1.177 2.59-2.634V2.659C12.459 1.255 11.268 0 9.922 0zm1.19 12.964H3.554v-2.813h7.557v2.813zm.02-5.959H3.535v-.899h.454c0-.669.094-1.301.41-1.896.36-.677.936-1.219 1.626-1.52V1.61H8.64v1.082c.704.31 1.296.87 1.653 1.57.297.58.383 1.196.383 1.844h.454v.9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#628BF5",
    d: "M9.806 6.106H4.862c0-.658.116-1.271.517-1.804.393-.524.924-.774 1.52-.966v-.827h.87v.827c.491.158.94.345 1.313.729.543.56.724 1.27.724 2.041zM4.428 11.05v1.014h5.814V11.05H4.428z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#1AC1B1",
    d: "M1.046 0h.622v15.349h-.622V0z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#1AC1B1",
    d: "M0 14.685V18l1.074-.916L2.15 18v-2.657H.657c-.364 0-.657-.293-.657-.658z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuActive);
export default __webpack_public_path__ + "static/media/menu-active.13ef372a88f61ff064ed829971c693a9.svg";
export { ForwardRef as ReactComponent };